// Layout for the recheck surfaces (bead hf-e6-commitments-coverage-udt.5).
//
// CSS-only, like every other feature stylesheet here.
//
// THE ONE LAYOUT DECISION THAT IS A PRODUCT DECISION: the two answers sit in a row
// with equal `flex: 1` and the same minimum target size. A "Yes" that filled the card
// and a "No" tucked underneath as a link would be the same coercion as a default
// answer, expressed in CSS instead of in copy (plan §10.9, §10.10). On a narrow
// screen they stack, and they stack EQUAL.
export const recheckStylesheet = `
.recheck-list { display: grid; gap: var(--space-16, 1rem); }
.recheck-list h2 { margin: 0; }
.recheck-list__items { display: grid; gap: var(--space-16, 1rem);
  list-style: none; margin: 0; padding: 0; }

.recheck-card__heading { margin: 0; font-weight: 600; }
.recheck-card__introduction { margin: 0 0 var(--space-12, 0.75rem);
  color: var(--color-ink-muted, #5b6862); }
.recheck-card__window { display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem);
  align-items: baseline; margin: var(--space-12, 0.75rem) 0; }
.recheck-card__time { color: var(--color-ink-muted, #5b6862); }

.recheck-diff { display: grid; gap: var(--space-8, 0.5rem); margin: 0;
  border: 1px solid var(--color-border, #d7ded9); border-radius: var(--radius-8, 0.5rem);
  padding: var(--space-12, 0.75rem); background: var(--color-surface-sunken, #f4f7f5); }
.recheck-diff__row { display: grid; gap: var(--space-4, 0.25rem); }
.recheck-diff dt { font-weight: 600; }
.recheck-diff dd { display: flex; flex-wrap: wrap; gap: var(--space-16, 1rem); margin: 0; }
.recheck-diff__was, .recheck-diff__now { display: flex; gap: var(--space-8, 0.5rem); }
.recheck-diff__label { color: var(--color-ink-muted, #5b6862); }
/* The old value is muted and struck through so the new one reads as current at a
   glance — never as the only signal, since the "Was" label carries the meaning in
   text for anyone who cannot see the styling. */
.recheck-diff__was span:last-child { color: var(--color-ink-muted, #5b6862);
  text-decoration: line-through; }

.recheck-card__answers { display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem);
  margin-top: var(--space-16, 1rem); }
.recheck-card__answers > * { flex: 1 1 12rem; min-height: var(--target-size-44, 2.75rem); }

.recheck-audience__group { margin-top: var(--space-12, 0.75rem); }
.recheck-audience__title { margin: 0 0 var(--space-4, 0.25rem);
  font-size: var(--font-size-14, 0.875rem); }
.recheck-audience__people { list-style: none; margin: 0; padding: 0;
  display: flex; flex-wrap: wrap; gap: var(--space-8, 0.5rem); }
.recheck-audience__done { margin: 0; color: var(--color-ink-muted, #5b6862); }
`;
